import React, { createContext, useState, useContext } from 'react';

interface PreviewData {
  title: string;
  setTitle: (title: string) => void;
  featureImageUrl: string | null;
  setFeatureImageUrl: (url: string | null) => void;
  step: number;
  setStep: (step: number) => void;
  latitude: string;
  setLatitude: (latitude: string) => void;
  longitude: string;
  setLongitude: (longitude: string) => void;
  selectedCategory: number | null;
  setSelectedCategory: (id: number | null) => void;
  categories: any[];
  setCategories: (categories: any[]) => void;
  excerpt: string;
  setExcerpt: (excerpt: string) => void;
  selectedTags: number[];
  setSelectedTags: (tags: number[]) => void;
  allTags: any[];
  setAllTags: (tags: any[]) => void;
  selectedFeatures: number[];
  setSelectedFeatures: (features: number[]) => void;
  allFeatures: any[];
  setAllFeatures: (features: any[]) => void;
  selectedPointTypes: number[];
  setSelectedPointTypes: (pointTypes: number[]) => void;
  allPointTypes: any[];
  setAllPointTypes: (pointTypes: any[]) => void;
}

const PreviewContext = createContext<PreviewData | undefined>(undefined);

export const PreviewProvider: React.FC = ({ children }) => {
  const [title, setTitle] = useState<string>("");
  const [featureImageUrl, setFeatureImageUrl] = useState<string | null>(null);
  const [step, setStep] = useState(1);
  const [latitude, setLatitude] = useState<string>("");
  const [longitude, setLongitude] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [categories, setCategories] = useState<any[]>([]);
  const [excerpt, setExcerpt] = useState<string>("");
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [allTags, setAllTags] = useState<any[]>([]);
  const [selectedFeatures, setSelectedFeatures] = useState<number[]>([]);
  const [allFeatures, setAllFeatures] = useState<any[]>([]);
  const [selectedPointTypes, setSelectedPointTypes] = useState<number[]>([]);
  const [allPointTypes, setAllPointTypes] = useState<any[]>([]);

  return (
    <PreviewContext.Provider value={{ title, setTitle, featureImageUrl, setFeatureImageUrl, step, setStep, latitude, setLatitude, longitude, setLongitude, selectedCategory, setSelectedCategory, categories, setCategories, excerpt, setExcerpt, selectedTags, setSelectedTags, allTags, setAllTags, selectedFeatures, setSelectedFeatures, allFeatures, setAllFeatures, selectedPointTypes, setSelectedPointTypes, allPointTypes, setAllPointTypes }}>
      {children}
    </PreviewContext.Provider>
  );
};

export const usePreview = () => {
  const context = useContext(PreviewContext);
  if (context === undefined) {
    throw new Error('usePreview must be used within a PreviewProvider');
  }
  return context;
};
